module.exports = __webpack_public_path__ + "img/bot-left-bg-mobile.1b97f186.png";